module.exports = __webpack_public_path__ + "static/img/brand6.6a8c563.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/brand/brand6.png
// module id = iG8P
// module chunks = 1